export default "//static.tradera.net/touchweb/static/output/images/category-postcards-pictures.facbab97.svg";